"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utils = require("../utils");

require("../asset/index.css");

var _excluded = ["attrs"],
    _excluded2 = ["icon", "primaryColor", "secondaryColor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6',
  calculated: false
};

function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || (0, _utils.getSecondaryColor)(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}

function getTwoToneColors() {
  return _objectSpread({}, twoToneColorPalette);
}

var IconBase = {
  name: 'IconBase',
  functional: true,
  props: {
    icon: Object,
    primaryColor: String,
    secondaryColor: String,
    calculated: Boolean
  },
  render: function render(h, ctx) {
    var _ctx$data = ctx.data;
    _ctx$data = _ctx$data === void 0 ? {} : _ctx$data;
    var attrs = _ctx$data.attrs,
        restData = (0, _objectWithoutProperties2["default"])(_ctx$data, _excluded),
        _ctx$props = ctx.props,
        props = _ctx$props === void 0 ? {} : _ctx$props,
        listeners = ctx.listeners;

    var _attrs$props = _objectSpread(_objectSpread({}, attrs), props),
        icon = _attrs$props.icon,
        primaryColor = _attrs$props.primaryColor,
        secondaryColor = _attrs$props.secondaryColor,
        restProps = (0, _objectWithoutProperties2["default"])(_attrs$props, _excluded2);

    var colors = twoToneColorPalette;

    if (primaryColor) {
      colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, _utils.getSecondaryColor)(primaryColor)
      };
    } // useInsertStyles();


    (0, _utils.warning)((0, _utils.isIconDefinition)(icon), "icon should be icon definiton, but got ".concat(icon));

    if (!(0, _utils.isIconDefinition)(icon)) {
      return null;
    }

    var target = icon;

    if (target && typeof target.icon === 'function') {
      target = _objectSpread(_objectSpread({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
      });
    }

    return (0, _utils.generate)(h, target.icon, "svg-".concat(target.name), _objectSpread(_objectSpread({}, restData), {}, {
      attrs: _objectSpread(_objectSpread({
        'data-icon': target.name
      }, _utils.svgBaseProps), restProps),
      on: listeners
    }));
  }
};
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
var _default = IconBase;
exports["default"] = _default;